import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const BUILD_A_SENTENCE_ACTIVITY_FRAGMENT = gql `
  fragment BuildASentenceActivityFragment on BuildASentenceActivity {
    buildSentenceInstructions {
      id
      audio {
        ...AssetFragment
      }
      text
    }
    typeSentenceInstructions {
      id
      audio {
        ...AssetFragment
      }
      text
    }
    rounds {
      dropdowns {
        id
        name
        answers {
          id
          answer
          monochromeImage {
            id
            image {
              id
              src
            }
          }
          colorImage {
            id
            image {
              id
              src
            }
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default BUILD_A_SENTENCE_ACTIVITY_FRAGMENT;
